export const NAV = {
  dashboard: 'nav-dashboard',
  customers: 'nav-customers',
  requests: 'nav-requests',
  appointments: 'nav-appointments',
  satisfactions: 'nav-satisfactions',
  audit: 'nav-audit',
  settings: 'nav-settings',
};

export const DASH = {
  root: 'dashboard-root',
  metricTotalCustomers: 'metric-total-customers',
  metricNewRequests: 'metric-new-requests',
  metricInDesign: 'metric-in-design',
  metricOfferSent: 'metric-offer-sent',
  metricAwaitingApproval: 'metric-awaiting-approval',
  metricAwaitingDeposit: 'metric-awaiting-deposit',
  metricConfirmed: 'metric-confirmed',
  metricTodaysAppointments: 'metric-todays-appointments',
  metricMonthlyDeposit: 'metric-monthly-deposit',
  metricMonthlyVolume: 'metric-monthly-volume',
  metricSatisfactionPending: 'metric-satisfaction-pending',
  metricActivePersonnel: 'metric-active-personnel',
};

export const CUSTOMERS = {
  addButton: 'customers-add-button',
  searchInput: 'customers-search-input',
  table: 'customers-table',
  formFullName: 'customer-form-full-name',
  formPhone: 'customer-form-phone',
  formEmail: 'customer-form-email',
  formInstagram: 'customer-form-instagram',
  formCity: 'customer-form-city',
  formDistrict: 'customer-form-district',
  formBirthDate: 'customer-form-birth-date',
  formSource: 'customer-form-source',
  formType: 'customer-form-type',
  formNotes: 'customer-form-notes',
  formSubmit: 'customer-form-submit',
};

export const REQUESTS = {
  addButton: 'requests-add-button',
  kanbanColumn: (status) => `requests-kanban-col-${status}`,
  requestCard: (id) => `request-card-${id}`,
  detailStatusSelect: 'request-detail-status-select',
  detailSaveButton: 'request-detail-save-button',
  depositButton: 'request-detail-deposit-button',
  generateConsentButton: 'request-detail-generate-consent-button',
  // Phase 1.7 — Next Step & Accordion
  nextStepCard: 'request-next-step-card',
  nextStepCta: 'request-next-step-cta',
  nextStepSkip: 'request-next-step-skip',
  nextStepSkipDialog: 'request-next-step-skip-dialog',
  nextStepSkipReason: 'request-next-step-skip-reason',
  nextStepSkipConfirm: 'request-next-step-skip-confirm',
  nextStepSkippedBadge: 'request-next-step-skipped-badge',
  accordionDetails: 'request-accordion-details',
  accordionPricing: 'request-accordion-pricing',
  accordionFiles: 'request-accordion-files',
  accordionAppointments: 'request-accordion-appointments',
};

export const ACTIONS = {
  root: 'dashboard-actions-root',
  tab: (key) => `actions-tab-${key}`,
  panel: (key) => `actions-panel-${key}`,
  row: (key, id) => `actions-row-${key}-${id}`,
  detailBtn: (key, id) => `actions-detail-${key}-${id}`,
  waBtn: (key, id) => `actions-wa-${key}-${id}`,
};

// Phase 1.8 — SLA Tracking
export const SLA = {
  statsCard: (key) => `sla-stats-${key}`,
  criticalBadge: 'sla-critical-badge',
  approachingBadge: 'sla-approaching-badge',
  overdueBadge: 'sla-overdue-badge',
  targetText: 'sla-target-text',
  remainingText: 'sla-remaining-text',
  overdueText: 'sla-overdue-text',
};

// Phase 1.9.1 — Commissions
export const COMMISSION = {
  completeButton: 'appt-complete-button',
  completeModal: 'appt-complete-modal',
  totalPriceInput: 'commission-total-price',
  discountInput: 'commission-discount',
  additionalInput: 'commission-additional',
  tipInput: 'commission-tip',
  materialInput: 'commission-material',
  otherInput: 'commission-other',
  collectedInput: 'commission-collected',
  paymentMethodSelect: 'commission-payment-method',
  tipPolicySelect: 'commission-tip-policy',
  materialBeforeSwitch: 'commission-material-before',
  noteInput: 'commission-note',
  summaryPanel: 'commission-summary-panel',
  summaryArtistTotal: 'commission-summary-artist-total',
  summaryShopTotal: 'commission-summary-shop-total',
  summaryRemaining: 'commission-summary-remaining',
  saveButton: 'commission-save-button',
  cancelButton: 'commission-cancel-button',
  artistModelSection: 'artist-commission-model-section',
  artistModelTypeSelect: 'artist-model-type',
  artistRateInput: 'artist-rate-input',
  artistFixedFeeInput: 'artist-fixed-fee',
  artistTipPolicySelect: 'artist-tip-policy',
  artistMaterialBeforeSwitch: 'artist-material-before',
  artistModelSaveButton: 'artist-model-save',
  recomputeButton: 'commission-recompute-button',
};

// Phase 1.9.3 — Payouts
export const PAYOUTS = {
  root: 'payouts-page-root',
  navLink: 'nav-payouts',
  statCard: (key) => `payouts-stat-${key}`,
  filterArtist: 'payouts-filter-artist',
  filterBranch: 'payouts-filter-branch',
  filterStatus: 'payouts-filter-status',
  eligibleRow: (id) => `payouts-eligible-row-${id}`,
  eligibleCheckbox: (id) => `payouts-eligible-cb-${id}`,
  bulkPayButton: 'payouts-bulk-pay-button',
  bulkModal: 'payouts-bulk-modal',
  paymentMethodSelect: 'payouts-payment-method',
  paymentReferenceInput: 'payouts-payment-reference',
  bankAccountInput: 'payouts-bank-account',
  descriptionInput: 'payouts-description',
  bulkConfirmButton: 'payouts-bulk-confirm',
  payoutRow: (id) => `payouts-row-${id}`,
  payoutDetailButton: (id) => `payouts-detail-btn-${id}`,
  reverseButton: (id) => `payouts-reverse-btn-${id}`,
  reverseDialog: 'payouts-reverse-dialog',
  reverseReasonInput: 'payouts-reverse-reason',
  reverseConfirm: 'payouts-reverse-confirm',
  tabEligible: 'payouts-tab-eligible',
  tabHistory: 'payouts-tab-history',
};

// Phase 1.9.2 — Artists page
export const ARTIST_PAGE = {
  root: 'artists-page-root',
  navLink: 'nav-artists',
  viewCards: 'artists-view-cards',
  viewTable: 'artists-view-table',
  filterBranch: 'artists-filter-branch',
  filterActive: 'artists-filter-active',
  card: (id) => `artist-card-${id}`,
  row: (id) => `artist-row-${id}`,
  detailRoot: 'artist-detail-root',
  tab: (key) => `artist-detail-tab-${key}`,
  overviewPanel: 'artist-overview-panel',
  appointmentsPanel: 'artist-appointments-panel',
  commissionsPanel: 'artist-commissions-panel',
  performancePanel: 'artist-performance-panel',
  personnelPanel: 'artist-personnel-panel',
  commissionRow: (id) => `artist-commission-row-${id}`,
};

export const SETTINGS = {
  branchAddButton: 'settings-branch-add-button',
  artistAddButton: 'settings-artist-add-button',
  slaSection: 'settings-sla-section',
  slaRow: (key) => `settings-sla-row-${key}`,
  slaMinutesInput: (key) => `settings-sla-minutes-${key}`,
  slaEnabledSwitch: (key) => `settings-sla-enabled-${key}`,
  slaSaveButton: 'settings-sla-save-button',
  slaResetButton: 'settings-sla-reset-button',
};

export const APPTS = {
  addButton: 'appointments-add-button',
  list: 'appointments-list',
};

export const CONSENT = {
  fullNameInput: 'consent-full-name-input',
  phoneInput: 'consent-phone-input',
  emailInput: 'consent-email-input',
  kvkkCheckbox: 'consent-kvkk-checkbox',
  explicitCheckbox: 'consent-explicit-checkbox',
  marketingCheckbox: 'consent-marketing-checkbox',
  mediaCheckbox: 'consent-media-checkbox',
  procedureCheckbox: 'consent-procedure-checkbox',
  depositCheckbox: 'consent-deposit-checkbox',
  submitButton: 'consent-submit-button',
  successMessage: 'consent-success-message',
};
